import type { CallAnalysisTagDefinitionChoice } from '@reach/shared-types/call-analysis-tag-definitions';

export interface ChoiceFields {
  displayName: string;
  tooltipDescription: string;
  color: string;
  textColor: string;
  icon: string;
}

export function buildChoice(value: string, fields: ChoiceFields): CallAnalysisTagDefinitionChoice {
  const trimmedValue = value.trim();
  const trimmedDisplayName = fields.displayName.trim();
  const trimmedTooltipDescription = fields.tooltipDescription.trim();
  const trimmedColor = fields.color.trim();
  const trimmedTextColor = fields.textColor.trim();
  const trimmedIcon = fields.icon.trim();
  const out: CallAnalysisTagDefinitionChoice = { value: trimmedValue };
  if (trimmedDisplayName) out.displayName = trimmedDisplayName;
  if (trimmedTooltipDescription) out.tooltipDescription = trimmedTooltipDescription;
  if (trimmedColor) out.color = trimmedColor;
  if (trimmedTextColor) out.textColor = trimmedTextColor;
  if (trimmedIcon) out.icon = trimmedIcon;
  return out;
}

export function applyPendingChoiceEdit(
  choices: CallAnalysisTagDefinitionChoice[],
  editingChoiceValue: string,
  fields: ChoiceFields,
): CallAnalysisTagDefinitionChoice[] {
  return choices.map(choice =>
    choice.value === editingChoiceValue ? buildChoice(choice.value, fields) : choice,
  );
}
